export const mockProductList = [
	{
		id: 1,
		images_url: [""],
		price: 0,
		name: "",
		collection_status: false,
	},
];

export const mockProduct = {
	id: 0,
	images_url: [""],
	name: "",
	price: 0,
	color: "",
	collection_status: false,
	description: "",
	details: [""],
};

export const mockWishlist = [];
